<template>
  <div class="main-conent main-conent-minheight">
    <el-card shadow="never" class="border-none search">
      <search slot="header" @change="goSearch"></search>

      <img-cards
        :data="data"
        :loading="loading"
        @show-model="showModel"
      ></img-cards>

      <div class="margin-t16 text-right">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="limit"
          :current-page="page"
          @current-change="goPage"
        >
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import showImgDetail from './components/model/index'
import ImgCards from './components/cards'
import Search from './components/search'
import { getPictures } from '@/service/spore'
import { weekBegin, formatDate } from '@/utlis/date'

export default {
  components: { ImgCards, Search },
  data() {
    return {
      query: {
        deviceId: null
      },
      loading: false,
      searchOpen: false,
      total: 0,
      limit: 21,
      page: 1,
      data: [],
      detail: null
    }
  },
  mounted() {
    this.query = {
      limit: this.limit,
      companyId: this.companyId,
      deviceId: this.spores && this.spores[0] ? this.spores[0].id : null,
      beginDate: weekBegin(),
      endDate: formatDate(undefined, 'YYYY-MM-DD')
    }
    this.getData(this.query)
  },
  methods: {
    async getData(query = {}) {
      this.loading = true
      const { data } = await getPictures(query)
      const { paging, pictures } = data
      this.total = paging.count
      this.page = paging.page
      this.data = pictures.map(p => ({
        id: p.id,
        createdAt: formatDate(p.createdAt),
        title: `${p.device} - ${p.id}`,
        src: p.storePath
      }))
      this.loading = false
    },
    goSearch(query) {
      this.query = query
      this.getData(this.getSearch())
    },
    goPage(page) {
      let query = this.getSearch()
      if (page > 1) query.page = page
      this.getData(query)
    },
    getSearch() {
      let query = { limit: this.limit }
      Object.keys(this.query).forEach(k => {
        if (this.query[k]) {
          query[k] = this.query[k]
        }
      })
      return query
    },
    showModel(id) {
      showImgDetail({ id, list: this.data })
    }
  }
}
</script>
